import { useThemeContext } from '@/viewmodel/shared/theme/hooks/useThemeContext';

export const useIsDark = (): boolean => useThemeContext().isDark;
